import { render } from "./PersonRoleComponent.vue?vue&type=template&id=cc36bdbc"
import script from "./PersonRoleComponent.vue?vue&type=script&lang=js"
export * from "./PersonRoleComponent.vue?vue&type=script&lang=js"

import "./PersonRoleComponent.vue?vue&type=style&index=0&id=cc36bdbc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__